import * as React from 'react';
import { SVGProps } from 'react';

const IconSpeedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 8.725C2 5.6 4.648 3 8 3s6 2.6 6 5.725a5.538 5.538 0 0 1-1.356 3.624l1.518 1.302A7.54 7.54 0 0 0 16 8.725C16 4.42 12.38 1 8 1S0 4.42 0 8.725c0 1.875.693 3.593 1.838 4.926l1.518-1.302A5.539 5.539 0 0 1 2 8.725Z" />
    <path d="M7.332 10.34c.615.429 1.45.294 1.864-.3.415-.596 2.016-5.264 2.016-5.264S7.385 7.893 6.97 8.487c-.415.595-.253 1.425.362 1.853Z" />
  </svg>
);
export default IconSpeedSizeS;
